import PropTypes from "prop-types";
import { TextField } from "react-aria-components";
import { Controller, useFormContext } from "react-hook-form";

export const BaseAriaFormController = ({
	Component = TextField,
	children,
	name,
	rules,
	...rest
}) => {
	const { control } = useFormContext();

	return (
		<Controller
			control={control}
			name={name}
			rules={rules}
			render={({ field }) => (
				<Component {...field} {...rest}>
					{children}
				</Component>
			)}
		/>
	);
};

BaseAriaFormController.propTypes = {
	Component: PropTypes.any,
	children: PropTypes.any.isRequired,
	name: PropTypes.string.isRequired,
	rules: PropTypes.object,
};
